<input
  type="text"
  class="form-control"
  [formControl]="customformControl"
  [placeholder]="placeholder"
  (input)="onInput($event)"
  (blur)="_onTouch($event)" />
